module.exports = __webpack_public_path__ + "static/media/InfoIconBlack.0ee03c79.svg";